import React from 'react';

export default () => <div />;



// WEBPACK FOOTER //
// ./src/components/Icon/AllBinary.tsx